import React from "react"
import { Types } from "../../../../../../rpcs/dist/EpisodeRPC"
import { ContentActionDispatcher } from "../../../../actiondispacher/content-action-dispacher"
import { EDIT_TYPE, IEditorContent } from "../../../../types"
import { Edit } from "./types/edit"
import { Remove } from "./types/remove"
import { Show } from "./types/show"

interface IProps {
  index: number
  content: IEditorContent
  prevContent: IEditorContent | null
  actions: ContentActionDispatcher
  isLast: boolean
}

export const EditContentContext = (props: IProps) => {
  // アンケートで編集メニュー出した際に再描写しないよう例外的に処理
  if (
    props.content.type === Types.Survey &&
    [EDIT_TYPE.SHOW, EDIT_TYPE.MENU].includes(props.content._editMetaData.type)
  ) {
    return (
      <Show
        content={props.content}
        isLast={props.isLast}
        prevContent={props.prevContent}
        actions={props.actions}
      />
    )
  }

  switch (props.content._editMetaData.type) {
    case EDIT_TYPE.SHOW:
      return (
        <Show
          content={props.content}
          isLast={props.isLast}
          prevContent={props.prevContent}
          actions={props.actions}
        />
      )

    case EDIT_TYPE.EDIT:
    case EDIT_TYPE.MENU:
      return <Edit content={props.content} prevContent={props.prevContent} />

    case EDIT_TYPE.REMOVE:
      return <Remove content={props.content} actions={props.actions} />

    default:
      return null
  }
}
